module.exports = __webpack_public_path__ + "img/puzzle_33.46998220.png";